/**
 * PickerModeToggle — segmented control switching the customizer between building a
 * custom layered look and picking a ready-made avatar.
 */

import { Pressable, Text, View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { useMemo } from 'react';
import {
  getPickerModeToggleStyles,
  getSegmentStyle,
  getSegmentTextStyle,
} from './PickerModeToggle.styles';

export type PickerMode = 'custom' | 'ready';

interface PickerModeToggleProps {
  mode: PickerMode;
  onChange: (mode: PickerMode) => void;
}

const SEGMENTS: { id: PickerMode; label: string }[] = [
  { id: 'custom', label: 'Custom' },
  { id: 'ready', label: 'Ready Avatars' },
];

export function PickerModeToggle({ mode, onChange }: PickerModeToggleProps) {
  const theme = useTheme();
  const styles = useMemo(() => getPickerModeToggleStyles(theme), [theme]);

  return (
    <View style={styles.track} accessibilityRole="tablist">
      {SEGMENTS.map((segment) => {
        const active = segment.id === mode;
        return (
          <Pressable
            key={segment.id}
            onPress={() => onChange(segment.id)}
            accessibilityRole="tab"
            accessibilityState={{ selected: active }}
            style={getSegmentStyle(styles, active)}
          >
            <Text style={getSegmentTextStyle(styles, active)}>{segment.label}</Text>
          </Pressable>
        );
      })}
    </View>
  );
}
